import React, { forwardRef } from 'react';
import { Card } from 'react-bootstrap';

const Subscription = forwardRef((props, ref) => {
 return (
  <Card className="mb-3" id="subscriptions" ref={ref}>
   <Card.Header className="bg-light">
    <h5 className="mb-0">Servicio de pago</h5>
   </Card.Header>
   <Card.Body>
    <h6 className="text-primary">Servicios Pagos</h6>
    <ol type="1">
     <li>
      Si utiliza nuestros servicios y supera los límites de los servicios gratuitos que ofrecemos, la sección "Servicio de pago"
      se aplica a usted
     </li>
     <li>
      El "Pago de la factura" son las tarifas pagaderas por su factura, como se le indica cuando utiliza nuestro servicio más allá
      del límite de uso gratuito. Deberá pagar el pago de la factura por el término de su uso pagado.
     </li>
     <li>
      No se le cobrará por el uso de nuestros servicios hasta que su uso supere el límite de uso gratuito. Al final de cada mes
      (si ha utilizado más allá de nuestro límite de uso gratuito), generaremos una factura que incluirá su información de uso y
      la cantidad adeudada para ese mes.
     </li>
     <li>
      Las tarifas de facturación se pagan en la moneda especificada al registrarse en el servicio y no incluyen el impuesto al
      valor agregado (o cualquier otro impuesto sobre las ventas aplicable), que se agregará a la tasa correspondiente.
     </li>
    </ol>
    <hr className="my-4" />
    <h6 className="text-primary">Tarjetas de crédito</h6>
    <ol>
     <li>
      Si es un usuario de pago o tiene un saldo pendiente con nosotros, nos proporcionará información válida de su tarjeta de
      crédito y nos autorizará a deducir los cargos de la factura mensual de esa tarjeta de crédito (si ha utilizado más allá del
      límite de uso gratuito).
     </li>
     <li>
      No almacenamos la información de la tarjeta que proporcionó, sino que utilizamos Stripe. Debe reemplazar la información de
      cualquier tarjeta de crédito que haya vencido con información de una tarjeta de crédito válida diferente.
     </li>
     <li>
      Puede agregar varias tarjetas de crédito en nuestro servicio, pero solo la tarjeta marcada como principal se utilizará para
      cobrarle por el uso de servicios pagados.
     </li>
    </ol>
    <hr className="my-4" />
    <h6 className="text-primary">Reembolsos</h6>
    <ol>
     <li>No aplicables: No tiene derecho a un reembolso por nuestra parte, ya que se trata de un servicio pospago.</li>
     <li>
      Errores de software: Si su factura incluye información inapropiada debido a un error de software u otro motivo, le
      reembolsaremos el monto adicional cobrado dentro de los 14 días hábiles posteriores a su descubrimiento. Deberá informarnos
      sobre el monto adicional cobrado.
     </li>
    </ol>
   </Card.Body>
  </Card>
 );
});

export default Subscription;
